import LegalPage from "@/components/site/LegalPage";
import { breadcrumbLd } from "@/lib/jsonld";

export default function Privacy() {
    return (
        <LegalPage
            testId="page-privacy"
            title="Privacyverklaring"
            intro="Human Design Studio hecht waarde aan je privacy. In deze verklaring lees je welke gegevens ik verzamel, waarom, en wat je rechten zijn."
            seo={{
                title: "Privacyverklaring | Human Design Studio",
                description:
                    "Privacyverklaring van Human Design Studio: welke gegevens ik verzamel, waarom, en jouw rechten.",
                path: "/privacy",
                jsonLd: [breadcrumbLd("Privacyverklaring", "/privacy")],
            }}
            sections={[
                {
                    h2: "Wie ik ben",
                    body: [
                        "Human Design Studio, Marcel van der Veen. Contact: info@humandesignstudio.nl, telefoon 06-46090104. KvK: 64008304. Btw: NL167130171B02. Adres: Jupiterweg 19a108, 8938 AD Leeuwarden.",
                    ],
                },
                {
                    h2: "Welke gegevens ik verzamel",
                    body: [
                        [
                            "Bij een boeking: naam, e-mailadres, telefoonnummer, en je geboortedatum, geboortetijd en geboorteplaats. Die laatste drie gebruik ik om je bodygraph te maken; zonder die gegevens kan ik de sessie niet voorbereiden.",
                            "Bij aanmelding voor de gratis Q&A: naam en e-mailadres, en je vraag als je die invult.",
                            "Bij het contactformulier: naam, e-mailadres, telefoonnummer (optioneel) en je bericht.",
                        ],
                    ],
                },
                {
                    h2: "Waarom ik ze gebruik",
                    body: [
                        "Om je sessie of aanmelding te verwerken, contact met je op te nemen, en (met jouw toestemming) je op de hoogte te houden. Grondslag: uitvoering van de overeenkomst en jouw toestemming.",
                    ],
                },
                {
                    h2: "Je geboortegegevens",
                    body: [
                        "Deze zijn gevoelig. Ik vraag ze alleen als het nodig is, bewaar ze niet langer dan nodig, en deel ze niet met anderen. Je geeft er bij het boeken expliciet toestemming voor.",
                    ],
                },
                {
                    h2: "Met wie ik gegevens deel",
                    body: [
                        "Met partijen die nodig zijn om de dienst te leveren, zoals de betaaldienst (Mollie) en mijn e-mailprovider (Resend) voor bevestigingsmails. Zij verwerken alleen wat nodig is. Ik verkoop je gegevens nooit.",
                    ],
                },
                {
                    h2: "Beveiliging",
                    body: [
                        "Ik neem passende technische en organisatorische maatregelen om je gegevens te beschermen tegen verlies en onbevoegde toegang.",
                    ],
                },
                {
                    h2: "Hoe lang ik ze bewaar",
                    body: [
                        "Boekings- en factuurgegevens bewaar ik 7 jaar (wettelijke fiscale bewaarplicht). Je geboortegegevens verwijder ik kort na de sessie, uiterlijk na 3 maanden. Aanmeldingen voor de Q&A en contactberichten bewaar ik tot je je afmeldt, en maximaal 2 jaar na het laatste contact.",
                    ],
                },
                {
                    h2: "Je rechten",
                    body: [
                        "Inzage, correctie, verwijdering, en bezwaar. Stuur daarvoor een bericht naar info@humandesignstudio.nl. Je kunt ook een klacht indienen bij de Autoriteit Persoonsgegevens.",
                    ],
                },
                {
                    h2: "Cookies",
                    body: ["Deze site gebruikt geen tracking-cookies."],
                },
                {
                    body: [
                        "Deze privacyverklaring kan ik van tijd tot tijd aanpassen. Laatst bijgewerkt: juli 2026.",
                    ],
                },
            ]}
        />
    );
}
